import { Component, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';


import { Router } from '@angular/router';
import { AppointmentService } from '../../services/appointment.service';
import { PersonService } from '../../services/person.service';
import { OfficeService } from '../../services/office.service';

export interface UsersData {
  name: string;
  id: number;
}


@Component({
  selector: 'app-over-appointment',
  templateUrl: './over-appointment.component.html',
  styleUrls: ['./over-appointment.component.css']
})
export class OverAppointmentComponent implements OnInit {

  action: string;
  local_data: any;
  appointment: any = {};
  officeId: any;
  procedureTypes: any;
  person: any;
  docNumber: string;
  gender: 'M';
  cities: any[];
  city: any = {};
  offices: any[];
  office: any = {};
  sectionalTypes: any[];
  sectionalType: any = {};
  sectionalItems: any[];
  sectionalItem: any = {};
  stampTypes: any[];
  stampType: any = {};

  transactionNumber: any;
  controlNumber: any;
  model: any;
  codeNumbermaxlength = 4;
  phoneNumbermaxlength = 8;
  phoneNumberValid: boolean;
  mailValid: boolean;
  phoneNumber: any;

  constructor(
    public dialogRef: MatDialogRef<OverAppointmentComponent>,
    private snackBar: MatSnackBar,
    private personService: PersonService,
    private officeService: OfficeService,
    private router: Router,
    private appointmentService: AppointmentService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: UsersData) {
    this.local_data = { ...data };
    this.action = this.local_data.action;
  }

  ngOnInit(): void {
    this.officeId = JSON.parse(localStorage.getItem('currentOffice')).id;
    this.officeService.getAllSecureSectionalTypes().subscribe((response: any) => {
      this.sectionalTypes = response;
    }, (e: any) => {
      if (e.status === 409) {
        this.snackBarMessage(e.error.message, 5000);
      } else {
        this.snackBarMessage('Ocurrio un problema', 5000);
      }
    });
  }

  doAction() {
    this.dialogRef.close({ event: 'Accept', data: this.local_data });
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }

  searchApplicant(docNumber: string, gender: string) {
    if (!this.docNumber) {
      this.snackBarMessage('Debe ingresar un número de documento', 5000);
      return;
    }
    if (!this.gender) {
      this.snackBarMessage('Debe ingresar un genero', 5000);
      return;
    }
    this.personService.searchApplicant(docNumber, gender).subscribe((response: any) => {
      this.person = response;
      this.docNumber = null;
      this.gender = null;
    }, (e: any) => {
      if (e.status === 409) {
        this.snackBarMessage(e.error.message, 5000);
      } else {
        this.snackBarMessage('Ocurrio un problema', 5000);
      }
    });
  }

  snackBarMessage(msg: any, duration: any) {
    this.snackBar.open(msg, '', {
      duration: duration, panelClass: ['blue-snackbar']
    });
  }

  getSectionalItemsBySectionalType(id: any) {
    this.officeService.getSectionalItemsBySectionalType(id).subscribe((response: any) => {
      this.controlNumber = null;
      this.transactionNumber = null;
      if (response && response.length > 0) {
        this.sectionalItems = response;
        this.sectionalItem.id = this.sectionalItems[0].id;
        this.getStampBySectionalItem(this.sectionalItem.id);
      } else {
        this.sectionalItems = [];
        this.stampTypes = [];
        this.stampType = {};
      }
    }, (e: any) => {
      if (e.status === 409) {
        this.snackBarMessage(e.error.message, 5000);
      } else {
        this.snackBarMessage('Ocurrio un problema', 5000);
      }
    });
  }

  getStampBySectionalItem(id: any) {
    this.officeService.getStampBySectionalItem(id).subscribe((response: any) => {
      if (response && response.length > 0) {
        this.stampTypes = response;
      } else {
        this.stampTypes = [];
        this.stampType = {};
      }
    }, (e: any) => {
      if (e.status === 409) {
        this.snackBarMessage(e.error.message, 5000);
      } else {
        this.snackBarMessage('Ocurrió un problema', 5000);
      }
    });
  }

  cancelAppointment() {
    this.router.navigateByUrl('/pages/appointment-form');
  }

  sendAppointment() {
    if (!this.person) {
      this.snackBarMessage('Debe buscar una persona', 5000);
      return;
    }

    if (!this.phoneNumberValid) {
      this.snackBarMessage('El código de área o el número de teléfono no son correctos', 5000);
      return;
    }
    //if (!this.person.email) {
    //  this.snackBarMessage('Debe ingresar un email', 5000);
    //  return;
    //}

    if (!this.sectionalType) {
      this.snackBarMessage('Debe seleccionar un tipo de trámite', 5000);
      return;
    }

    const model: any = {};
    model.applicant = this.person;
    model.dateFrom = new Date().toISOString().split('T')[0];
    model.dateTo = new Date().toISOString().split('T')[0];
    model.email = this.person.email;
    model.phoneNumber = `${this.person.codeNumber}${this.person.phoneNumber}`;
    model.overschedule = true;
    model.office = { id: this.officeId };
    model.sectionalType = { id: this.sectionalType.id };

    if (this.sectionalItem && this.sectionalItem.id) {
      model.sectionalItemRequestList = [{}];
      model.sectionalItemRequestList[0].sectionalItem = { id: this.sectionalItem.id };

      if ((this.stampTypes && this.stampTypes.length > 0) && !this.stampType.id) {
        this.snackBarMessage('Debe seleccionar un tipo de sellado', 5000);
        return;
      }
      if (this.stampType && this.stampType.id) {
       //if (!this.transactionNumber) {
       //  this.snackBarMessage('Debe ingresar un número de transacción', 5000);
       //  return;
       //}
       //if (!this.controlNumber) {
       //  this.snackBarMessage('Debe ingresar un número de control', 5000);
       //  return;
       //}

        model.sectionalItemRequestList[0].stampTicket = { controlNumber: this.controlNumber, stamp: { id: this.stampType.id }, transactionNumber: this.transactionNumber };
      }
    }
    this.dialogRef.close({ event: 'Accept', data: model });
  }

  validPhoneNumber() {
    if (this.person.codeNumber && this.person.codeNumber[0] == '0') {
      this.snackBarMessage('El código de area no puede empezar con 0', 5000);
      this.phoneNumberValid = false;
      return;
    }
    if (this.person.codeNumber && this.person.codeNumber.length <= 1) {
      this.snackBarMessage('El código de area debe tener al menos dos números', 5000);
      this.phoneNumberValid = false;
      return;
    }

    switch (this.person.codeNumber.length) {
      case 2:
        this.phoneNumbermaxlength = 8;
        this.phoneNumberValid = this.person.phoneNumber && this.person.phoneNumber.length < 8 ? false : true;
        break;
      case 3:
        this.phoneNumbermaxlength = 7;
        this.phoneNumberValid = this.person.phoneNumber && this.person.phoneNumber.length < 7 ? false : true;
        break;
      case 4:
        this.phoneNumbermaxlength = 6;
        this.phoneNumberValid = this.person.phoneNumber && this.person.phoneNumber.length < 6 ? false : true;
        break;
      default:
        break;
    }
  }

  validEmail() {
    if (this.person.email) {
      const regex = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/ig);
      const test = regex.test(this.person.email);
      this.mailValid = test ? true : false;
    }
  }


  close() {
    this.person = null;
    this.docNumber = null;
    this.gender = null;
  }
}
